module.exports = __webpack_public_path__ + "static/media/no3_100.53a8768a.png";